<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-main" v-if="!fullscreen">
      <router-link class="navbar-brand" to="/">
        <span>sekvoia</span>
        <span class="dot">.</span>
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fal fa-dot-circle fa-2x"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <!-- <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/services">
              <span>Services</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/technologies">
              <span>Technologies</span>
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link class="nav-link" to="/projects">
              <span>Projects</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">
              <span>Contact</span>
            </router-link>
          </li>
        </ul> -->
        <span class="navbar-text ml-auto">
          <a href="tel:48518523478">
            <i class="fal fa-phone"></i>(+48) 518-523-478
          </a>
        </span>
      </div>
    </nav>
    <router-view/>
    <section id="main-footer">
      <div class="row">
        <div class="col-10 mx-auto">
          <div class="row justify-content-between">
            <div class="col-12 col-md-6 col-lg-3">
              <h6>About Us</h6>
              <p>Sekvoia is an innovative digital agency with a vast experience in creative web solutions and office based in Warsaw, Poland.</p>
              <p>
                VAT ID: PL9482522539<br> REGON: 363470440
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <h6>Contact</h6>
              <p>
                Tomasz Zaborski<br> 
                <a href="mailto:contact@sekvoia.co">contact@sekvoia.co</a>
                <br>
                <a href="tel:48518523478">+48 518523478</a>
                <br>
                <i class="fab fa-skype"></i>&nbsp; <a href="skype:tom.zaborski">tom.zaborski</a>
              </p>
            </div>
            <div class="col-12 col-md-12 col-lg-3">
              <h6>Location</h6>
              <!-- <Map></Map> -->
              <p>ul. Tadeusza Borowskiego 2/320 <br>03-475 Warszawa, Poland</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import Map from "@/components/Map.vue";
import router from "./router";

export default {
  name: "app",
  data() {
    return {
      fullscreen: false
    };
  },
  components: {
    Map
  },
  mounted() {
    router.beforeEach((to, from, next) => {
      this.fullscreen = to.meta.fullscreen;
      next();
    });
  },
  methods: {

  }
};
</script>
<style lang="scss">
#app {
  background: #000;
  color: #efefef;
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
}

nav.navbar-main {
  padding: 0 40px;
  height: 120px;
  font-family: "Montserrat", sans-serif;
  .navbar-brand {
    span {
      color: #fff;
      font-weight: 700;
      font-size: 1.75rem;
      &.dot {
        color: #92ce11;
      }
    }
  }
  .nav-item {
    &.active {
      .nav-link {
        //border-bottom: 1px solid red;
      }
    }
  }
  .nav-link {
    color: #fff;
    padding: 0 20px;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    text-transform: lowercase;
    display: inline-block;

    span {
      position: relative;
      display: inline-block;
    }
    span:after {
      display: block;
      content: "";
      width: 0;
      height: 1px;
      background: #fff;
      position: absolute;
      opacity: 0;
      transition: all 0.5s ease-in-out, bottom 0.2s ease-out;
      bottom: 0;
    }
    &.router-link-active,
    &:hover {
      span:after {
        opacity: 1;
        width: 100%;
      }
    }
    .router-link-active:hover {
      span:after {
        bottom: -0.25rem;
      }
    }
  }
  .navbar-text a {
    font-weight: 400;
    color: #fff;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#main-footer {
  background: #0c0c0c;
  padding: 65px 0;
  a {
    color: #FFF;
    text-underline-position: below;
    &:hover {
      text-decoration: underline;
    }
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg.navbar-main .navbar-nav .nav-link {
    padding: 0 20px;
  }
}
</style>
